import React from 'react'

const NotFound = () => {
  return (
    <div
         class="container text-center mb-4 my-5">
    <h1 class="fw-bold m-4" >404 Not Found</h1>
    <p class="fs-5">Sorry, the page you are looking for does not exist.</p>

    
    </div>
  )
}

export default NotFound